import ChangeRequestApi from '../../../common/api/zeiterfassungServerApi/ChangeRequestApi';
import { ChangeRequestTile } from './ChangeRequestTile/ChangeRequestTile';
import { Heading } from '~/common/components/defaultUIComponents';
import { ChangeRequestFilters } from './ChangeRequestFilters';
import { Flex, Grid, GridItem } from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React, { useState, useEffect } from 'react';
import { Pagination } from './Pagination';

type FilterState = {
  type?: number;
  project?: number;
  employee?: string;
};

export const ChangeRequests: React.FC = () => {
  const translate = useTranslate();
  const [filterState, setFilterState] = useState<FilterState>({});
  const [page, setPage] = useState(0);

  const [{ data: changeRequests }, refetch] =
    ChangeRequestApi.hooks.useChangeRequestsQuery(page, filterState);

  const recordCount = changeRequests ? changeRequests.length : 0;

  useEffect(() => {
    refetch();
  }, [filterState, refetch]);

  return (
    <>
      <Heading mb={5}>{translate('changeRequest.dashboard')}</Heading>
      <ChangeRequestFilters
        filterState={filterState}
        setFilterState={setFilterState}
      />
      <Flex w="100%" direction="column" alignItems="center">
        <Pagination page={page} setPage={setPage} totalRecords={recordCount} />
        <Grid templateColumns="repeat(2, 1fr)" gap={3}>
          {changeRequests?.map((cr) => (
            <GridItem key={cr.id}>
              <ChangeRequestTile changeRequest={cr} />
            </GridItem>
          ))}
        </Grid>
        <Pagination page={page} setPage={setPage} totalRecords={recordCount} />
      </Flex>
    </>
  );
};
